import { withOAuth } from "aws-amplify-react";
import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Styles/ScreenStyles";

class OAuthButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props.classes,
      OAuthSignIn: props.OAuthSignIn
    };
  }

  render() {
    if (this.state.classes) {
      return (
        <main className={this.state.classes.main}>
          <CssBaseline />
          <Paper className={this.state.classes.paper}>
            <Avatar className={this.state.classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              ExSI
            </Typography>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={this.state.classes.submit}
              onClick={this.state.OAuthSignIn}
            >
              Je me connecte via FARO
            </Button>
          </Paper>
        </main>
      );
    }
  }
}

export default withOAuth(withStyles(styles)(OAuthButton));
